import { useState } from "react";
import { Button, InputField, TextArea, THEME } from "@myloc/myloc-gui";
import { useTranslate } from "../../../../../../language/i18n";
import Label from "../../../../../shared/Label/Label";
import styles from "./AttributesAndInstructionStep.module.scss";
import { Attribute, OrderDefinition, Product } from "../../../../../../services/registerAction/types";

interface AttributesAndInstructionStepProps {
  product: Product;
  selectedDefinition: OrderDefinition | null;
  onSubmit: (data: { instruction: string; attributes: Attribute[] }) => void;
  isLoading?: boolean;
}

const AttributesAndInstructionStep = ({
  product,
  selectedDefinition,
  onSubmit,
  isLoading,
}: AttributesAndInstructionStepProps) => {
  const translate = useTranslate();
  const [instruction, setInstruction] = useState("");
  const [attributes, setAttributes] = useState<Attribute[]>(
    product.makes?.map(make => ({
      id: make.id,
      label: make.label,
      value: make.value,
      maxLength: make.maxLength,
    })) ?? [],
  );

  const handleAttributeChange = (index: number, newValue: string) => {
    setAttributes(prev => {
      const updated = [...prev];

      updated[index] = { ...updated[index], value: newValue };

      return updated;
    });
  };

  const handleSubmit = () => {
    onSubmit({
      instruction,
      attributes,
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.selectedAction}>
        <Label label={translate("SELECTED_ACTION")} value={selectedDefinition?.name ?? selectedDefinition?.orderType} />
      </div>

      {attributes.length > 0 && (
        <div className={styles.attributeFields}>
          {attributes.map((attr, index) => (
            <InputField
              key={attr.id}
              label={attr.label}
              value={attr.value}
              maxLength={attr.maxLength}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleAttributeChange(index, e.target.value)}
              onFocus={undefined}
              onBlur={undefined}
              customInvalidMessage={undefined}
              customWarningMessage={undefined}
              customCssClass=""
              customInputCssClass=""
              customFieldIconCss=""
              required={false}
              disabled={false}
              readOnly={false}
              id={attr.id}
              selectInput={undefined}
              onClear={undefined}
            />
          ))}
        </div>
      )}

      <div className={styles.instructionField}>
        <TextArea
          label={translate("INSTRUCTION")}
          value={instruction}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setInstruction(e.target.value)}
          required
          disabled={false}
        />
      </div>

      <div className={styles.actions}>
        <Button
          theme={THEME.PRIMARY}
          customCssClass=""
          onClick={handleSubmit}
          disabled={instruction.trim() === ""}
          isLoading={isLoading}
        >
          {translate("CREATE")}
        </Button>
      </div>
    </div>
  );
};

export default AttributesAndInstructionStep;
